import UiReducer from './UiReducer';
import EmployeeReducer from './EmployeeReducer';
import DashBoardReducer from './DashBoardReducer';
import MasterReducer from './MasterReducer';
import UserReducer from './UserReducer';
import RegisterReducer from './RegisterReducer';

const rootReducer = {
	ui: UiReducer.reducer,	
	employee: EmployeeReducer.reducer,
	dash: DashBoardReducer.reducer,
	master: MasterReducer.reducer,
	user: UserReducer.reducer,
	register: RegisterReducer.reducer,
};

export default rootReducer;
